import * as Gallery from 'react-photoswipe-gallery';
export default Gallery;
// photoswipe: 4.1.3
// react-photoswipe-gallery: 1.3.4



